/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Test_ErrorInputs */

const en_admin_settings_test_error = /** @type {(inputs: Admin_Settings_Test_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test failed`)
};

/**
* | output |
* | --- |
* | "Test failed" |
*
* @param {Admin_Settings_Test_ErrorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_test_error = /** @type {((inputs?: Admin_Settings_Test_ErrorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Test_ErrorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_test_error(inputs)
});
export { admin_settings_test_error as "admin.settings.test.error" }